import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";

const drawerWidth = 280;

const useStyles = makeStyles(() => ({
  drawerPaper: {
    width: drawerWidth,
    boxSizing: "border-box",
    padding: 20,
    top: 65,
    bottom: 0,
    height: "auto",
    scrollbarWidth: "none",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },
  drawerOpen: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1000,
    /*[theme.breakpoints.down("md")]: {
      position: "fixed"
    }*/
  },
  drawerClosed: {
    width: 0
  }
}));

const InfoDrawer = ({
  open,
  children,
  variant = "persistent",
  anchor = "right",
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Drawer
      variant={variant}
      anchor={anchor}
      open={open}
      classes={{
        paper: classes.drawerPaper
      }}
      className={open ? classes.drawerOpen : classes.drawerClosed}
      {...rest}
    >
      {children}
    </Drawer>
  );
};

export default InfoDrawer;
